import { render, staticRenderFns } from "./purrateview_wg.vue?vue&type=template&id=2e5deeca&scoped=true&"
import script from "./purrateview_wg.vue?vue&type=script&lang=js&"
export * from "./purrateview_wg.vue?vue&type=script&lang=js&"
import style0 from "./purrateview_wg.vue?vue&type=style&index=0&id=2e5deeca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5deeca",
  null
  
)

export default component.exports